import {type ConsentInformation, consentInformationFromObject} from "../domain/types/consentInformation.js";
import {AppType, appType} from "../../global/appInfo.js";
import {ConsentProviderNotInitializedError} from "./types/ConsentProviderNotInitializedError.js";

export async function getConsentInformation(): Promise<ConsentInformation> {
    let uncheckedConsentInformation: Record<string, unknown> | undefined;
    if (appType() == AppType.ANDROID) {
        const rawConsentInformation = window.o_apps_android?.getConsentInformation?.()
        if (rawConsentInformation) uncheckedConsentInformation = JSON.parse(rawConsentInformation)

        if (uncheckedConsentInformation?.error === 'OneTrust not initialized') {
            throw new ConsentProviderNotInitializedError();
        }
    } else if (appType() == AppType.IOS) {
        uncheckedConsentInformation = await window.webkit?.messageHandlers?.getConsentInformation?.postMessage({});
    }

    if (!uncheckedConsentInformation) {
        throw Error("Consent information retrieved from client was undefined.")
    }

    return consentInformationFromObject(uncheckedConsentInformation);
}
